/** Возвращает безопасное пользовательское сообщение из неизвестной ошибки */
export const getErrorMessage = (error: unknown, fallback: string): string =>
    error instanceof Error && error.message
        ? error.message
        : fallback;
